// extracted by mini-css-extract-plugin
export default {"widget-header":"subscriptionrenewal_widget-header__HecyB","widget-body":"subscriptionrenewal_widget-body__lH9FP","dropdown-disabled":"subscriptionrenewal_dropdown-disabled__Khe06"};